module.exports = __webpack_public_path__ + "img/mercado-municipal.cc723209.jpg";